












































import Vue from 'vue';
import RoutePaths from '@/router/route_paths';

export default Vue.extend({
  name: 'RapidTestInstructions',
  data() {
    return {
      loading: true,
    };
  },
  async mounted(): Promise<void> {
    this.$store.commit('setMainLoading', false);
  },
  methods: {
    onResults(): void {
      this.$router.push({
        path: RoutePaths.RAPID_TEST_RESULTS,
      });
    },
    onGetStarted(): void {
      if (this.$store.getters.isRapidTestAllowed) {
        if (this.$store.state.user.realName && this.$store.state.user.realName !== '') {
          this.$router.push({
            path: RoutePaths.RAPID_TEST,
          });
        } else {
          this.$store.commit('setUsernamePopup', true);
        }
      } else {
        this.$store.commit('setMobileLinksPopup', true);
      }
    },
  },
});
